const getPrimaryColor = (appColor?: string) => (appColor as any) || 'blue';
const getSecondaryColor = (secondaryColor?: string) => (secondaryColor as any) || ('grey' as 'grey');
const getErrorColor = (appColor?: string) => (appColor === 'red' ? 'deepOrange' : 'red');

export { getPrimaryColor, getSecondaryColor, getErrorColor };
